<!-- composant pastilles s'il y a des sous étapes -->
<ng-template #pastillesTemplate>
  <div class="d-flex gap-1 align-items-center ms-auto">
    <span (click)="getOtherSubStep(displayedStep)"
          [ngClass]="{'active bg-grad-blue' : currentSubStep.id === displayedStep.id}"
          class="pastille rounded pointer"></span>
    <span (click)="getOtherSubStep(s)" [ngClass]="{'active bg-grad-blue pointer-ev-none' : s.id === currentSubStep.id}"
          class="pastille rounded pointer"
          *ngFor="let s of displayedStep.childs; let index = index;trackBy:stateTrackBy"></span>
    <p
      class="mediumGray minitext_3 ps-1 text-nowrap">{{ currentSubStep.id === displayedStep.id ? 1 : (displayedStep.childs.indexOf(currentSubStep) + 2) }}
      / {{ nbSubSteps }}</p>
  </div>
</ng-template>

<!-- page content -->
<div class="w-100 flex-grow-1 template_text content_container">
  <div class="bg-grey d-flex flex-column">

    <div class="d-flex gap-16 align-items-center">
      <div class="pills bg-grad-blue text-white subtitle_1 lh-1">
        {{ displayedStep['main_order'] }}
      </div>

      <h2 class="title_1 mb-0 text-grad-blue">
        {{ currentSubStep['title_' + locale] }}
      </h2>

      <ng-container *ngIf="displayedStep.type !== 'single' && !isMobile">
        <ng-container *ngTemplateOutlet="pastillesTemplate"></ng-container>
      </ng-container>
    </div>

    <div class="img_container d-block d-lg-none position-relative w-100">
      <!--        <img class="img-cover br-8" fill [ngSrc]="displayedStep.image" [alt]="imgAltText">-->
      <img class="img-cover br-8" fill
           [ngSrc]="'https://livinfrance-bk.s3.eu-west-3.amazonaws.com/post_bookings/' + locale + '-mobile-post_booking_general.svg'"
           [alt]="imgAltText">
    </div>

    <div class="text_2" [innerHTML]="currentSubStep['content_'+locale]"></div>


    <button *ngIf="displayedStep.order === 1" id="post_reservation-dlCertificate" type="button" role="button"
            class="btn btn-lf-secondary w-fit-content d-flex gap-2 align-items-center" (click)="downloadCertificate()"
            [disabled]="isFetchingCertificate">
      {{ 'PROCESSES.ACCOMMODATION.POST_RESERVATION_V2.DOWNLOAD_HOUSING_CERTIFICATE' | translate }}
      <span *ngIf="isFetchingCertificate" class="spinner-border spinner-border-sm position-relative"></span>
    </button>
    <div class="d-flex justify-content-between">
      <button id="post_reservation-getHelp" type="button" role="button" class="btn btn-interaction w-fit-content"
              (click)="getHelp()">
        {{ 'COMMON.NEED_HELP' | translate }}
      </button>


      <ng-container *ngIf="currentSubStep.type !== 'single' && isMobile">
        <ng-container *ngTemplateOutlet="pastillesTemplate"></ng-container>
      </ng-container>
    </div>

  </div>
</div>
